<template>
  <chat-message :prev-chat="prevChat" :chat="chat" @delete="$emit('delete', chat)">
    <ul :class="[style['select-options'], style['multi-select']]">
      <li
        v-for="(option, index) in selectOptions"
        :key="index"
        :class="[style['mini-margin'], checkOptionState(index)]"
        @click="clickOption(index)"
      >
        {{ option.text }}
      </li>
    </ul>
    <ul class="chat-message__actions">
      <li
        v-for="(action, index) in actions"
        :key="index"
        v-theme-bg-hover
        @click="clickAction(action)"
      >
        {{ action.text }}
      </li>
    </ul>
  </chat-message>
</template>

<script>
import ActionWidget from './ActionWidget.vue'
import { Chat } from 'src/apis'
import style from './scss/_select_options.scss'

export default {
  extends: ActionWidget,
  data() {
    return {
      style,
      selectOptions: this.initialSelectOptions(),
      actions: this.initialActions()
    }
  },
  methods: {
    checkOptionState(index) {
      if (this.selectOptions[index].selected === true) {
        return 'choosen'
      }
    },
    clickOption(index) {
      this.selectOptions[index].selected = !this.selectOptions[index].selected
    },
    clickAction(action) {
      if (action.action === 'see_all') {
        this.seeAll()
      } else {
        this.sendSelectionOptions()
      }
    },
    seeAll() {
      this.selectOptions = this.chat.message_rich.select_options
      this.actions = this.chat.message_rich.actions
    },
    sendSelectionOptions() {
      const selectedOptions = this.selectOptions.filter((option) => option.selected === true)
      const messageAction = JSON.stringify({ data: selectedOptions.map((option) => option.action) })
      const replyText = selectedOptions.map((option) => option.text).join('\n')
      Chat.sendMessage(replyText, { messageAction, messageID: this.chat.id })
    },
    initialSelectOptions() {
      if (this.chat.message_rich.popular_options) {
        return this.chat.message_rich.popular_options
      } else {
        return this.chat.message_rich.select_options
      }
    },
    initialActions() {
      if (this.chat.message_rich.popular_actions) {
        return this.chat.message_rich.popular_actions
      } else {
        return this.chat.message_rich.actions
      }
    }
  }
}
</script>
